import React, { useEffect } from "react";
import clsx from "clsx";

import { ConfirmationModal } from "components/ConfirmationModal";
import { Container } from "components/Container";
import { useIsMobile } from "hooks/useMobile";

import { StripeKyc } from "./StripeKYC";
import { SelectAnotherCompany } from "./SelectAnotherCompany";
import styles from "./StripeConfirmationModal.module.scss";

export const StripeConfirmationModal = ({
  visible,
  driverProfileId,
  driverProfile,
  allFleets = [],
  onFleetChange,
  selectedFleet,
}) => {
  const isMobile = useIsMobile();

  useEffect(() => {
    if (isMobile && visible) {
      document?.body.classList.add(styles.overflowHidden);
    } else {
      document?.body.classList.remove(styles.overflowHidden);
    }

    return () => {
      document?.body.classList.remove(styles.overflowHidden);
    };
  }, [isMobile, visible]);

  if (isMobile && visible) {
    return (
      <div
        className={clsx(styles.stripeModalMobile, styles.stripeConfirmModal)}
      >
        <Container>
          <StripeKyc
            driverProfileId={driverProfileId}
            driverProfile={driverProfile}
            selectedFleetId={selectedFleet?.id}
            selectedFleetSlug={selectedFleet?.url_slug}
          >
            <SelectAnotherCompany
              allFleets={allFleets}
              onFleetChange={onFleetChange}
              selectedFleet={selectedFleet}
            />
          </StripeKyc>
        </Container>
      </div>
    );
  }

  return (
    <ConfirmationModal
      visible={visible}
      className={styles.stripeConfirmModal}
      footer={null}
      closable={false}
    >
      <Container>
        <StripeKyc
          driverProfileId={driverProfileId}
          driverProfile={driverProfile}
          selectedFleetId={selectedFleet?.id}
          selectedFleetSlug={selectedFleet?.url_slug}
        >
          <SelectAnotherCompany
            allFleets={allFleets}
            onFleetChange={onFleetChange}
            selectedFleet={selectedFleet}
          />
        </StripeKyc>
      </Container>
    </ConfirmationModal>
  );
};
